/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ClientControllerGetClientsParams,
  ClientLocationsDto,
  DomainErrorDto,
  GetClientFilterColumnsResponseDto,
  GetClientsResponseDto,
  ListClientsResponseDto
} from './pacApi.schemas';

import { axios } from '../../common/axios';
import type { ErrorType } from '../../common/axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const clientControllerListClients = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<ListClientsResponseDto>(
      {url: `/api/v1/account/client`, method: 'GET', signal
    },
      options);
    }




export const getClientControllerListClientsQueryKey = () => {
    return [
    `/api/v1/account/client`
    ] as const;
    }


export const getClientControllerListClientsQueryOptions = <TData = Awaited<ReturnType<typeof clientControllerListClients>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientControllerListClientsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerListClients>>> = ({ signal }) => clientControllerListClients(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientControllerListClientsQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerListClients>>>
export type ClientControllerListClientsQueryError = ErrorType<DomainErrorDto>


export function useClientControllerListClients<TData = Awaited<ReturnType<typeof clientControllerListClients>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientControllerListClients>>,
          TError,
          Awaited<ReturnType<typeof clientControllerListClients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerListClients<TData = Awaited<ReturnType<typeof clientControllerListClients>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientControllerListClients>>,
          TError,
          Awaited<ReturnType<typeof clientControllerListClients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerListClients<TData = Awaited<ReturnType<typeof clientControllerListClients>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClientControllerListClients<TData = Awaited<ReturnType<typeof clientControllerListClients>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientControllerListClientsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getClientControllerListClientsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof clientControllerListClients>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientControllerListClientsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerListClients>>> = ({ signal }) => clientControllerListClients(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientControllerListClientsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerListClients>>>
export type ClientControllerListClientsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useClientControllerListClientsSuspense<TData = Awaited<ReturnType<typeof clientControllerListClients>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerListClientsSuspense<TData = Awaited<ReturnType<typeof clientControllerListClients>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerListClientsSuspense<TData = Awaited<ReturnType<typeof clientControllerListClients>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClientControllerListClientsSuspense<TData = Awaited<ReturnType<typeof clientControllerListClients>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientControllerListClientsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const clientControllerListLocations = (
    clientId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<ClientLocationsDto>(
      {url: `/api/v1/account/client/${clientId}/locations`, method: 'GET', signal
    },
      options);
    }




export const getClientControllerListLocationsQueryKey = (clientId: string,) => {
    return [
    `/api/v1/account/client/${clientId}/locations`
    ] as const;
    }


export const getClientControllerListLocationsQueryOptions = <TData = Awaited<ReturnType<typeof clientControllerListLocations>>, TError = ErrorType<DomainErrorDto>>(clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientControllerListLocationsQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerListLocations>>> = ({ signal }) => clientControllerListLocations(clientId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientControllerListLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerListLocations>>>
export type ClientControllerListLocationsQueryError = ErrorType<DomainErrorDto>


export function useClientControllerListLocations<TData = Awaited<ReturnType<typeof clientControllerListLocations>>, TError = ErrorType<DomainErrorDto>>(
 clientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientControllerListLocations>>,
          TError,
          Awaited<ReturnType<typeof clientControllerListLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerListLocations<TData = Awaited<ReturnType<typeof clientControllerListLocations>>, TError = ErrorType<DomainErrorDto>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientControllerListLocations>>,
          TError,
          Awaited<ReturnType<typeof clientControllerListLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerListLocations<TData = Awaited<ReturnType<typeof clientControllerListLocations>>, TError = ErrorType<DomainErrorDto>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClientControllerListLocations<TData = Awaited<ReturnType<typeof clientControllerListLocations>>, TError = ErrorType<DomainErrorDto>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientControllerListLocationsQueryOptions(clientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getClientControllerListLocationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof clientControllerListLocations>>, TError = ErrorType<DomainErrorDto>>(clientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientControllerListLocationsQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerListLocations>>> = ({ signal }) => clientControllerListLocations(clientId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientControllerListLocationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerListLocations>>>
export type ClientControllerListLocationsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useClientControllerListLocationsSuspense<TData = Awaited<ReturnType<typeof clientControllerListLocations>>, TError = ErrorType<DomainErrorDto>>(
 clientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerListLocationsSuspense<TData = Awaited<ReturnType<typeof clientControllerListLocations>>, TError = ErrorType<DomainErrorDto>>(
 clientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerListLocationsSuspense<TData = Awaited<ReturnType<typeof clientControllerListLocations>>, TError = ErrorType<DomainErrorDto>>(
 clientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClientControllerListLocationsSuspense<TData = Awaited<ReturnType<typeof clientControllerListLocations>>, TError = ErrorType<DomainErrorDto>>(
 clientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerListLocations>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientControllerListLocationsSuspenseQueryOptions(clientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const clientControllerGetClients = (
    params?: ClientControllerGetClientsParams,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetClientsResponseDto>(
      {url: `/api/v1/account/client/query`, method: 'GET',
        params, signal
    },
      options);
    }




export const getClientControllerGetClientsQueryKey = (params?: ClientControllerGetClientsParams,) => {
    return [
    `/api/v1/account/client/query`, ...(params ? [params] : [])
    ] as const;
    }


export const getClientControllerGetClientsQueryOptions = <TData = Awaited<ReturnType<typeof clientControllerGetClients>>, TError = ErrorType<DomainErrorDto>>(params?: ClientControllerGetClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientControllerGetClientsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerGetClients>>> = ({ signal }) => clientControllerGetClients(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientControllerGetClientsQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerGetClients>>>
export type ClientControllerGetClientsQueryError = ErrorType<DomainErrorDto>


export function useClientControllerGetClients<TData = Awaited<ReturnType<typeof clientControllerGetClients>>, TError = ErrorType<DomainErrorDto>>(
 params: undefined |  ClientControllerGetClientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientControllerGetClients>>,
          TError,
          Awaited<ReturnType<typeof clientControllerGetClients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerGetClients<TData = Awaited<ReturnType<typeof clientControllerGetClients>>, TError = ErrorType<DomainErrorDto>>(
 params?: ClientControllerGetClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientControllerGetClients>>,
          TError,
          Awaited<ReturnType<typeof clientControllerGetClients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerGetClients<TData = Awaited<ReturnType<typeof clientControllerGetClients>>, TError = ErrorType<DomainErrorDto>>(
 params?: ClientControllerGetClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClientControllerGetClients<TData = Awaited<ReturnType<typeof clientControllerGetClients>>, TError = ErrorType<DomainErrorDto>>(
 params?: ClientControllerGetClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientControllerGetClientsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getClientControllerGetClientsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof clientControllerGetClients>>, TError = ErrorType<DomainErrorDto>>(params?: ClientControllerGetClientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientControllerGetClientsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerGetClients>>> = ({ signal }) => clientControllerGetClients(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientControllerGetClientsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerGetClients>>>
export type ClientControllerGetClientsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useClientControllerGetClientsSuspense<TData = Awaited<ReturnType<typeof clientControllerGetClients>>, TError = ErrorType<DomainErrorDto>>(
 params: undefined |  ClientControllerGetClientsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerGetClientsSuspense<TData = Awaited<ReturnType<typeof clientControllerGetClients>>, TError = ErrorType<DomainErrorDto>>(
 params?: ClientControllerGetClientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerGetClientsSuspense<TData = Awaited<ReturnType<typeof clientControllerGetClients>>, TError = ErrorType<DomainErrorDto>>(
 params?: ClientControllerGetClientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClientControllerGetClientsSuspense<TData = Awaited<ReturnType<typeof clientControllerGetClients>>, TError = ErrorType<DomainErrorDto>>(
 params?: ClientControllerGetClientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClients>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientControllerGetClientsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const clientControllerGetClientFilterColumns = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetClientFilterColumnsResponseDto>(
      {url: `/api/v1/account/client/query/filter-columns`, method: 'GET', signal
    },
      options);
    }




export const getClientControllerGetClientFilterColumnsQueryKey = () => {
    return [
    `/api/v1/account/client/query/filter-columns`
    ] as const;
    }


export const getClientControllerGetClientFilterColumnsQueryOptions = <TData = Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientControllerGetClientFilterColumnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>> = ({ signal }) => clientControllerGetClientFilterColumns(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientControllerGetClientFilterColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>>
export type ClientControllerGetClientFilterColumnsQueryError = ErrorType<DomainErrorDto>


export function useClientControllerGetClientFilterColumns<TData = Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>,
          TError,
          Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerGetClientFilterColumns<TData = Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>,
          TError,
          Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerGetClientFilterColumns<TData = Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClientControllerGetClientFilterColumns<TData = Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientControllerGetClientFilterColumnsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getClientControllerGetClientFilterColumnsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientControllerGetClientFilterColumnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>> = ({ signal }) => clientControllerGetClientFilterColumns(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientControllerGetClientFilterColumnsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>>
export type ClientControllerGetClientFilterColumnsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useClientControllerGetClientFilterColumnsSuspense<TData = Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerGetClientFilterColumnsSuspense<TData = Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientControllerGetClientFilterColumnsSuspense<TData = Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClientControllerGetClientFilterColumnsSuspense<TData = Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof clientControllerGetClientFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientControllerGetClientFilterColumnsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






